/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AlertApiConfiguration } from '../alert-api-configuration';
import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';

import { GetAlerts$Params, getAlerts } from '../fn/alert-list/get-alerts';
import { Alerts } from '../models/alerts';

/**
 * Alert list API
 */
@Injectable({ providedIn: 'root' })
export class AlertListService extends BaseService {
   constructor(config: AlertApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getAlerts()` */
   static readonly GetAlertsPath = '/api/alert/list';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getAlerts()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAlerts$Response(params?: GetAlerts$Params, context?: HttpContext): Observable<StrictHttpResponse<Alerts>> {
      return getAlerts(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getAlerts$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAlerts(params?: GetAlerts$Params, context?: HttpContext): Observable<Alerts> {
      return this.getAlerts$Response(params, context).pipe(map((r: StrictHttpResponse<Alerts>): Alerts => r.body));
   }
}
